import React from "react";
import NextImage, { ImageProps as NextImageProps } from "next/image";

export interface SacredImageProps extends Omit<NextImageProps, "placeholder"> {
  /**
   * Blurhash data URL for the placeholder.
   * On web, this should be a base64 Data URL.
   */
  blurhash?: string;
  placeholder?: "blur" | "empty";
}

/**
 * Standardized Image component for Ishvaram Web.
 * Uses Next.js Image for optimization and placeholder support.
 */
export const SacredImage = ({
  blurhash,
  placeholder,
  ...props
}: SacredImageProps) => {
  return (
    <NextImage
      placeholder={blurhash ? "blur" : placeholder || "empty"}
      blurDataURL={blurhash}
      {...props}
    />
  );
};
